/**
 * Shared component loading utilities
 * Extracted to avoid circular dependencies
 */
import * as umdComponents from '../web-components';

/**
 * Type definition for a map of component registration functions.
 * Used to organize components by category and variant.
 */
export interface ComponentMap {
  [key: string]: {
    [subKey: string]: () => void;
  };
}

/**
 * Utility function to register a collection of UMD web components.
 * Iterates through a ComponentMap and calls each registration function.
 */
export const loadComponentClass = (componentMap: ComponentMap) => {
  for (const key in componentMap) {
    if (Object.prototype.hasOwnProperty.call(componentMap, key)) {
      const component = componentMap[key];

      for (const subKey in component) {
        if (Object.prototype.hasOwnProperty.call(component, subKey)) {
          component[subKey]();
        }
      }
    }
  }
};

const allList = umdComponents as unknown as ComponentMap;

/**
 * @deprecated This function is deprecated and will be removed in version 2.0.
 * Use the bundle export instead:
 * ```typescript
 * import { initializeBundle } from '@universityofmaryland/web-components-library/bundle';
 * initializeBundle();
 * ```
 */
export const LoadUmdComponents = () => {
  console.error(
    '[DEPRECATED] LoadUmdComponents is deprecated.\n' +
      'Use: import { initializeBundle } from "@universityofmaryland/web-components-library/bundle"',
  );

  loadComponentClass(allList);
};